import React, {useState, useEffect} from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import {Container, Row, Col} from 'reactstrap';
import TextInput from '../../../Shared/TextInput/TextInput';
import {changeHandler, blurHandler, validateHandler, verifyPhone, clearIsValid, clearPhone} from './OTPVerifyPhoneSlice';
import {connect} from 'react-redux';

const otpVerifyPhone = (props) => {
  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.onSubmit && props.onSubmit == true) {
          props.validateHandler({form: props.form, isDisplayIdentity: props.isDisplayIdentity});
        }
      }
    },
    [props.onSubmit]
  );

  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      if (props.onSubmit && props.onSubmit == true) {
        props.validateHandler({form: props.form, isDisplayIdentity: props.isDisplayIdentity});
      }
    }
    props.clearIsValid();
    props.clearPhone();
  }, []);

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.form.valid !== '') {
          if (props.form.valid == false) props.clearIsValid();

          props.onValid(props.form.valid);
        }
      }
    },
    [props.form.valid]
  );

  return (
    <div className='container-fluid main'>
      <div className='otp-verify-code'>
        <Row>
          <Col ms={12}>
            <h1 className='main-title'>{props.title}</h1>
          </Col>
        </Row>
        <Row>
          <Col ms={12}>
            <h1 className='top-title'>{props.subTitle}</h1>
          </Col>
        </Row>
        <Row>
          <Col ms={12}>
            <p className='top-link'>{props.linkText}</p>
          </Col>
        </Row>
        <Row>
          <Col ms={12}>
            <div className='component-container'>
              <TextInput
                className='email-inp'
                required={true}
                autoComplete='off'
                name='phone'
                type='text'
                placeholder={props.placeholder ?? 'טלפון'}
                maxLength='10'
                value={props.form.phone}
                error={props.form.errors.phone}
                onChange={(e) => props.changeHandler({target: e.target, form: props.form})}
              />
              {props.comment && <div className='comment'>{props.comment}</div>}
              {props.isDisplayIdentity && (
                <TextInput
                  error={props.form.errors.id}
                  onChange={(e) => props.changeHandler({target: e.target, form: props.form})}
                  value={props.form.id}
                  name='id'
                  maxLength='9'
                  pattern='[0-9]*'
                  type='number'
                  placeholder='תעודת זהות'
                  required='required'
                />
              )}
            </div>
          </Col>
        </Row>

        {props.bottomLink != undefined && props.bottomLink != '' && (
          <Row>
            <Col ms={12}>
              <br />
              <p className='bottom-link'>{props.bottomLink}</p>
            </Col>
          </Row>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {form: state.otpVerifyPhone.form, saleType: state.saleBlock.saleType, productsInfo: state.saleBlock.productsInfo};
};

const mapDispatchToProps = {
  changeHandler,
  blurHandler,
  validateHandler,
  verifyPhone,
  clearIsValid,
  clearPhone,
};

export default connect(mapStateToProps, mapDispatchToProps)(otpVerifyPhone);
